export default __webpack_public_path__ + "static/services-details1a-f682069d2c7596f2bda2e443be605a2e.jpg";